import { profilePrefix } from ".";
import { apiUrl, _base_axios_post } from "..";

export default function generateDemoInternalAccessKey(query = {}) {
    return _base_axios_post(`${apiUrl}/${profilePrefix}/generateDemoInternalAccessKey`, query);
}
